import { Box, Typography, styled, type BoxProps } from '@mui/material';
import type { ReactNode } from 'react';

export interface EmptyStateProps extends BoxProps {
  illustration?: string;
  header?: string;
  description?: string;
  primaryAction?: ReactNode;
  secondaryAction?: ReactNode;
}

const Root = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(1),
}));

const Illustration = styled('img')(({ theme }) => ({
  height: '100px',
  minHeight: '100px',
  maxHeight: '100px',
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(1),
}));

const Header = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 600,
  marginBottom: theme.spacing(0.5),
}));

const Description = styled(Typography)({
  fontSize: '16px',
  maxWidth: '35em',
  textAlign: 'center',
});

const Actions = styled('div')({
  display: 'flex',
  flexDirection: 'row',
});

export const EmptyState = ({
  illustration,
  header,
  description,
  primaryAction,
  secondaryAction,
  ...boxProps
}: EmptyStateProps) => (
  <Root {...boxProps}>
    {/* Decorative: the header beside it carries the meaning. */}
    {illustration && <Illustration alt="" src={illustration} />}
    {header && <Header>{header}</Header>}
    {description && <Description>{description}</Description>}
    <Actions>
      {primaryAction && <Box>{primaryAction}</Box>}
      {secondaryAction && <Box>{secondaryAction}</Box>}
    </Actions>
  </Root>
);
